import React from 'react';
import { connect } from 'react-redux';
import TabLink from '../../components/TabLink';
import './Header.scss';
import { withRouter } from "react-router-dom";

function Header(props) {
    const query = props.location.search;

    return (
        <div className="manage-header">
            <h1 className="manage-header_title">{props.translation.title}</h1>
            <div className="manage-header_tabs">
                <TabLink {...{ text: props.translation.addressTab, to: `/manage${query}#address` }} />
                <TabLink {...{ text: props.translation.contactsTab, to: `/manage${query}#contacts` }} />
                <TabLink {...{ text: props.translation.usersTab, to: `/manage${query}#users` }} />
                <TabLink {...{ text: props.translation.managerTab, to: `/manage${query}#manager` }} />
                <TabLink {...{ text: props.translation.servicesTab, to: `/manage${query}#services` }} />
            </div>
        </div>
    );
}

export default withRouter(
    connect(state => ({ translation: state.translation.manage.header }))(Header)
);
